import { downloadShopOrderReceipt } from './orderReceiptDownload';

export async function completePublicGalleryOrderAfterPayment({
  response,
  activeCart,
  locale,
  orderType = 'retail',
  verifyPayment,
  createPublicOrder,
  toast,
  t,
  onPhaseChange,
}) {
  onPhaseChange?.('verifying');

  const verificationResult = await verifyPayment({
    razorpay_order_id: response.razorpay_order_id,
    razorpay_payment_id: response.razorpay_payment_id,
    razorpay_signature: response.razorpay_signature,
  });

  if (!verificationResult.success) {
    throw new Error('Payment verification failed');
  }

  if (!activeCart[0]?.customerName?.trim() || !activeCart[0]?.phone?.trim()) {
    toast.error(t('toast.orderAfterPaymentFail'));
    onPhaseChange?.(null);
    return null;
  }

  onPhaseChange?.('booking');

  const result = await createPublicOrder({
    customerName: activeCart[0].customerName,
    phone: activeCart[0].phone,
    orderType,
    paymentId: response.razorpay_payment_id,
    razorpay_order_id: response.razorpay_order_id,
    razorpay_payment_id: response.razorpay_payment_id,
    razorpay_signature: response.razorpay_signature,
    receiptLocale: ['en', 'mr', 'kn'].includes(locale) ? locale : 'mr',
    items: activeCart.map((item) => ({
      model: item.id,
      qty: item.quantity,
      advance: item.advanceAmount,
      customRequest: item.customRequest,
      deliveryDate: item.deliveryDate,
    })),
  });

  onPhaseChange?.('receipt');
  await downloadShopOrderReceipt(result, 'jpeg');

  onPhaseChange?.('success');
  return result;
}
